import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "saveButton"]
  static values = { saveUrl: String, saveMethod: String }

  connect() {
    this._baseline()
  }

  change() {
    this._checkDirty()
  }

  async save() {
    const conditionEls = this.element.querySelectorAll("[data-condition-id]")
    if (!conditionEls.length) return

    const formData = new FormData()
    formData.append("_method", "PATCH")

    conditionEls.forEach((el, i) => {
      el.querySelectorAll("[name]").forEach(input => {
        const field = input.name.match(/\[(\w+)\]$/)?.[1]
        if (field) formData.append(`conditions[${i}][${field}]`, input.value)
      })
    })

    const btn = this.saveButtonTarget
    btn.classList.add("opacity-50", "pointer-events-none")

    const resp = await fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "application/json"
      },
      body: formData
    })

    if (resp.ok) {
      btn.classList.add("hidden")
      btn.classList.remove("inline-flex", "opacity-50", "pointer-events-none")
      this._baseline()
    } else {
      btn.classList.remove("opacity-50", "pointer-events-none")
    }
  }

  _baseline() {
    this.inputTargets.forEach(input => {
      input.dataset.originalValue = input.value
    })
  }

  _checkDirty() {
    const dirty = this.inputTargets.some(input =>
      input.value !== input.dataset.originalValue
    )
    const btn = this.saveButtonTarget
    if (dirty) {
      btn.classList.remove("hidden")
      btn.classList.add("inline-flex")
    } else {
      btn.classList.add("hidden")
      btn.classList.remove("inline-flex")
    }
  }
}
